// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"BatchPopover_skeleton__3T8W2","batch":"BatchPopover_batch___joqY"};